"use strict";
angular.module("planCommandMonitorManuscriptDiffusionModule", [])
    .controller('planCommandMonitorManuscriptDiffusionCtrl', ['$scope', 'trsHttpService', '$q', '$stateParams', 'planCommandMonitorService', '$state', 'modalDialog',
        function($scope, trsHttpService, $q, $stateParams, planCommandMonitorService, $state, modalDialog) {
            initStatus();
            initData();
            /**
             * [initData description:初始化数据]
             */
            function initData() {
                requestData();
            }
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.status = {
                    curroute: ["策划中心", "指挥监测中心", "添加功能", "功能配置/功能说明"]
                };
                $scope.data = {};
            }
            /*
             *[requestData description:获取数据]
             */
            function requestData() {
                var params = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'addFuncMgr',
                    "method": 'getaddfunclist',
                    "sceneid": $stateParams.sceneid
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data = data.listr[0];
                });
            }
            /**
             * [addSelectedTopic description:编前选题添加按钮触发函数]
             */
            $scope.addSelectedTopic = function() {
                $scope.addParams = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'addFuncMgr',
                    "method": 'addFuncOther',
                    "sceneid": $stateParams.sceneid,
                    "addFlag": ($stateParams.addflg === "true") ? 1 : 0,
                };

                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.addParams, 'post').then(function(data) {
                    if (data.mapResult.status === "SUCCESS") {
                        modalDialog.alertType("", "添加成功", "success", true, function() {
                                $state.go('front.planningresource.commandMonitor.manuscriptanalysis.rankinglist', {}, { reload: "front.planningresource" });
                            },
                            function() {
                                requestData();
                            }, "", "留在当前页", "立即查看");
                    } else {
                        modalDialog.alertType("", "添加失败请重新更新", "error", "confirm");
                    }
                });
            };
        }
    ]);